<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <el-date-picker v-model="timevalue" size="small" type="datetimerange"
                      :picker-options="pickerOptions2" range-separator="至"
                      start-placeholder="开始日期" end-placeholder="结束日期"
                      align="right" value-format="yyyy-MM-dd HH:mm:ss">
      </el-date-picker>
      <div style="display: flex;justify-content: space-between">
        <input-search placeholder="姓名/手机号/住户/房间号" @search="searchKey" />
        <button-export
        :href="exportUrl"
        download="download.xls"
        style="margin-left:5px;"
        :beforeDownload="beforeDownload"
        value="导出"/>
      </div>
    </div>
    <div class="search-line">
      <div style="display: inline-block;color: #48576a;font-size: 14px;line-height: 30px;margin-right:3px">
        <span class="selectTitle">假期所在地</span>
        <el-select v-model="requestData.province" @change="provinceChange" placeholder="请选择" size="small" style="width: 140px;">
          <el-option
            v-for="item in provinceList"
            :key="item.label"
            :label="item.label"
            :value="item.label">
          </el-option>
        </el-select>
        <el-select v-model="requestData.city" @change="cityChange" placeholder="请选择" size="small" style="width: 140px;">
          <el-option
            v-for="item in cityList"
            :key="item.label"
            :label="item.label"
            :value="item.label">
          </el-option>
        </el-select>
        <el-select v-model="requestData.region" @change="regionChange" placeholder="请选择" size="small" style="width: 140px;">
          <el-option
            v-for="item in regionList"
            :key="item.label"
            :label="item.label"
            :value="item.label">
          </el-option>
        </el-select>
      </div>
      <div style="display: flex;justify-content: space-between">
        <input-select selectTitle="是否隔离" :selectKey="'isolationFlag'" :selectData="isolationFlagList" @search="search" style="margin: 0 5px 0 0;"/>
        <el-input placeholder="请输入" v-model="requestData.tempratureValue" size="small" style="width: 200px;" class="payDeadInput" type="number" @keyup.native.13="getPage" >
          <el-select v-model="tempratureValueStatus" slot="prepend" placeholder="请选择" class="prependSelect">
            <el-option label="体温超过" value="1"></el-option>
          </el-select>
          <template slot="append">℃</template>
        </el-input>
      </div>
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @changeSwitch="changeSwitch" @changeSelection="changeSelection" :total="total" :pageNum="requestData.pageNum" :pageSize="requestData.pageSize"  @changePagination="changePagination" :hasOperation="false" />
  </div>
</template>

<script>
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import ButtonAdd from '../../../components/Button/ButtonAdd'
import ButtonDelete from '../../../components/Button/ButtonDelete'
import ButtonExport from '../../../components/common/buttons/button-export'
import ButtonUpload from '../../../components/common/buttons/button-upload'
import InputSearch from '../../../components/Input/InputSearch'
import InputSelect from '../../../components/Input/InputSelect'
import TableMain from '../../../components/Table/TableMain'
import {api} from '../../api/epidemicSituation'
import {errorHandler} from '../../../utils/errorHandler'
import {nAlert, nSuccess} from '../../../utils/notice'
import {bus} from '../../../utils/bus'
import { cityData } from "../../../utils/citys"

export default {
  components: {
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    Breadcrumb},
  name: 'epidemic-situation-register',
  data () {
    return {
      permissionCodes: '',
      breadcrumb: [{
        value: '智慧防疫',
        name: 'epidemic-situation-register'
      }, {
        value: '体温监测'
      }],
      pickerOptions2: {
        disabledDate (time) {
          return time.getTime() > new Date(((new Date) / 1000 + 86400) * 1000)
        },
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      exportUrl: '',
      isolationFlagList: [
        {
          key: '',
          label: '全部'
        }, {
          key: '是',
          label: '是'
        }, {
          key: '否',
          label: '否'
        }
      ],
      tableHead: [{
        prop: 'personName',
        label: '姓名'
      }, {
        prop: 'sexText',
        label: '性别',
        width: '80',
      }, {
        prop: 'phone',
        label: '手机号'
      }, {
        prop: 'roomInfoName',
        label: '房间号'
      }, {
        prop: 'enterpriseName',
        label: '住户名称'
      }, {
        prop: "jqszd",
        label: "假期所在地"
      }, {
        prop: 'temprature',
        label: '体温值(℃)'
      }, {
        prop: 'isolationFlagState',
        label: '是否隔离',
        isSwitch: true
      }, {
        prop: 'createTime',
        label: '测温时间'
      }],
      tableData: [],
      total: 0,
      selectionArr: [],
      timevalue: [],
      tempratureValueStatus: '1',
      requestData: {
        startTime: '',
        endTime: '',
        isolationFlag: '',
        searchKey: '',
        tempratureValue: '',
        pageSize: 10,
        pageNum: 1,
        province: '',
        city: '',
        region: '',
      },
      provinceList: [],
      cityList: [],
      regionList: [],
    }
  },
  created () {
    this.permissionCodes = bus.global.permissionCodes
    let searchdata = this.$route.params.id
    if (searchdata === '1') {
      this.requestData.province = '湖北省'
    } else if (searchdata === '2') {
      this.requestData.province = '浙江省'
      this.requestData.city = '温州市'
    } else if (searchdata === '3') {
      this.requestData.province = '浙江省'
      this.requestData.city = '台州市'
    } else if (searchdata === '4') {
      this.requestData.province = '浙江省'
      this.requestData.city = '宁波市'
    }
    this.getCreatTime()
    this.provinceList = cityData
  },
  methods: {
    beforeDownload () {
      this.exportUrl = `${api.exportTempratureDetect}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${this.requestData.searchKey}&startTime=${this.requestData.startTime}&endTime=${this.requestData.endTime}&isolationFlag=${this.requestData.isolationFlag}&tempratureValue=${this.requestData.tempratureValue}`
    },
    getCreatTime () {
      let nowDate = new Date
      let year = nowDate.getFullYear()
      let month = (nowDate.getMonth() + 1) < 10 ? '0' + (nowDate.getMonth() + 1) : (nowDate.getMonth() + 1)
      let date = nowDate.getDate() < 10 ? '0' + nowDate.getDate() : nowDate.getDate()
      let hour = nowDate.getHours() < 10 ? '0' + nowDate.getHours() : nowDate.getHours()
      let minute = nowDate.getMinutes() < 10 ? '0' + nowDate.getMinutes() : nowDate.getMinutes()
      let second = nowDate.getSeconds() < 10 ? '0' + nowDate.getSeconds() : nowDate.getSeconds()
      this.timevalue[0] = year + '-' + month + '-01' + ' ' + '00:00:00'
      this.timevalue[1] = year + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + second
      this.getPage()
    },
    getPage () {
      if (this.timevalue) {
        this.requestData.startTime = this.timevalue[0]
        this.requestData.endTime = this.timevalue[1]
      } else {
        this.requestData.startTime = ''
        this.requestData.endTime = ''
      }
      this.$axios.post(api.getTempratureDetectPage, this.requestData)
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list
            data.map(v => {
              if (v.createTime) {
                  v.createTime = v.createTime.slice(0, 19)
              }
              if (v.sex === '0') {
                  v.sexText = '男'
              } else {
                  v.sexText = '女'
              }
              if (v.isolationFlag === '是') {
                v.isolationFlagState = true
              } else {
                v.isolationFlagState = false
              }
              if (v.province) {
                v.jqszd = `${v.province}${v.city}${v.region}`
              } else {
                v.jqszd = ``
              }
            })
            this.total = res.data.data.total
            this.tableData = data
          }
        })
        .catch(errorHandler('获取失败'))
    },
    search (v) {
      this.requestData.pageNum = 1
      this.requestData[v.key] = v.value
      this.getPage()
    },
    searchKey (v) {
      this.requestData.pageNum = 1
      this.requestData.searchKey = v
      this.getPage()
    },
    changePagination (data) {
      this.requestData.pageNum = data[0]
      this.requestData.pageSize = data[1]
      this.getPage()
    },
    changeSelection (codeArr) {
      this.selectionArr = codeArr
    },
    changeSwitch (data) {
      this.$confirm('是否确认修改隔离状态？', '提示')
        .then(() => {
          if (data.isolationFlagState) {
            data.isolationFlag = '是'
          } else {
            data.isolationFlag = '否'
          }
          for (let i in data) {
            if (data[i] === '--') {
              data[i] = ''
            }
          }
          this.$axios.post(api.isolationTempratureDetect, data)
            .then(res => {
              nSuccess('修改成功')
              this.getPage()
            })
            .catch(errorHandler('修改失败'))
        })
        .catch(() => {
          this.getPage()
        })
    },
    provinceChange (value) {
      this.provinceList.map(v => {
        if (v.label === value) {
          this.cityList = v.children
        }
      })
      this.requestData.city = ''
      this.requestData.region = ''
      this.getPage()
    },

    cityChange (value) {
      this.cityList.map(v => {
        if (v.label === value) {
          this.regionList = v.children
        }
      })
      this.requestData.region = ''
      this.getPage()
    },

    regionChange (value) {
      this.getPage()
    }
  },
  watch: {
    centEndTime(val) {
      this.getPage()
    },
    timevalue (val) {
      this.getPage()
    }
  }
}
</script>

<style scoped>
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-box {
    display: flex;
    justify-content: flex-start;
  }
  .prependSelect {
      width: 120px;
  }
</style>



// WEBPACK FOOTER //
// src/view/EpidemicSituation/Temperature/Temperature.vue